<div class="py-3 py-md-1 verticalDimensionPage">
  <div class="container" id="fullPage">
    <div class="card login-card">
      <div class="row justify-content-center">

        <!-- CAROUSEL IMAGES -->
        <div class="col-md-5 d-none d-lg-block align-self-center text-center" 
          style="border-right: 2px solid lightgray;">

          <div id="carousel" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-indicators" style="transform: translateY(26px); filter: invert(1);">
              <button *ngFor="let img of images; let i = index" type="button" data-bs-target="#carousel" [attr.data-bs-slide-to]="i"
              [class.active]="i === 0" [attr.aria-current]="i === 0 ? 'true' : null" [attr.aria-label]="'Slide ' + (i + 1)"></button>
            </div>

            <div class="carousel-inner">
              <div *ngFor="let img of images; let i = index" class="carousel-item" [ngClass]="{'active': i == 0}" data-bs-interval="2000">
                <img [src]="'assets/img/login/'+img.src" alt="login" class="login-card-img"
                [matTooltip]="img.description">
              </div>
            </div>
          </div>
        </div>

        <!-- LOGIN FORM -->
        <div class="col-md-7 col-12">
          <div class="card-body">
            <div class="languageBox">
              <app-language (lang)="changeLang($event)"></app-language>
            </div>
            <div class="brand-wrapper d-none d-md-block">
              <img src="assets/img/logo.png" alt="logo" class="logo">
            </div>
            <div class="brand-wrapper d-md-none text-center mt-2">
              <img src="assets/img/logo.png" alt="logo" class="logo">
            </div>
            <p class="login-card-description d-none d-md-block">{{"PROFILE.LOGIN.SIGNIN" | translate}}</p>
            <p class="login-card-description d-md-none text-center">{{"PROFILE.LOGIN.SIGNIN" | translate}}</p>
            <form [formGroup]="loginForm">
              <div class="form-group">
                <label for="email">{{"PROFILE.LOGIN.EMAIL" | translate}}</label>
                <input type="email" name="email" id="email" formControlName="email" class="form-control inputElement"
                  placeholder="{{'PROFILE.LOGIN.MAILPLACEHOLDER' | translate}}" [ngClass]="{'error': !valid}">
              </div>
              <div class="form-group mt-2" [ngClass]="{'mb-4': valid}" style="position: relative">
                <label for="password">{{"PROFILE.LOGIN.PSW" | translate}}</label>
                <input [type]="type" name="password" id="password" formControlName="password" class="form-control inputElement"
                  placeholder="***********" [ngClass]="{'error': !valid}">
                <i class="bi" [ngClass]="{'bi-eye': !toggled, 'bi-eye-slash': toggled}" id="togglePassword"
                  (click)="seePassword()"></i>
              </div>
              <div *ngIf="!valid" class="mb-4 text-center" style="color: #DC3545;">
                <small>{{"PROFILE.LOGIN.WRONGPSW" | translate}}</small>
              </div>
              <button [class.disabled]="loginForm.invalid" class="btn btn-block login-btn mb-4"
                (click)="login()">{{"PROFILE.LOGIN.LOGIN" | translate}}</button>
            </form>
            <div>
              <button routerLink="/sendemailModifyPassword" class="forgot-password-link btn ps-0">
                {{"PROFILE.LOGIN.FORGOTPSW" | translate}}
              </button>
            </div>
            <p class="login-card-footer-text">{{"PROFILE.LOGIN.SIGNUP" | translate}}
              <button routerLink="/signup" class="btn btn-link">{{"PROFILE.LOGIN.REGISTER" | translate}}</button>
            </p>
            <nav class="login-card-footer-nav">
              @if(lang == 'it'){
                  <a href="https://www.iubenda.com/privacy-policy/52431611" target="_blank" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe me-4" title="Privacy Policy ">Privacy Policy</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>
                  <a href="https://www.iubenda.com/termini-e-condizioni/52431611" target="_blank" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Termini e Condizioni ">Termini e Condizioni</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>
              }
              @else{
                  <a href="https://www.iubenda.com/privacy-policy/78584924" target="_blank" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe me-4" title="Privacy Policy ">Privacy Policy</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>
                  <a href="https://www.iubenda.com/terms-and-conditions/78584924" target="_blank" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Terms and Conditions ">Terms and Conditions</a><script type="text/javascript">(function (w,d) {var loader = function () {var s = d.createElement("script"), tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js"; tag.parentNode.insertBefore(s,tag);}; if(w.addEventListener){w.addEventListener("load", loader, false);}else if(w.attachEvent){w.attachEvent("onload", loader);}else{w.onload = loader;}})(window, document);</script>
              }
              <!-- <a href="#!" class="me-4">{{"PROFILE.LOGIN.USERTERMS" | translate}}</a>
              <a href="#!">{{"PROFILE.LOGIN.PRIVACY" | translate}}</a> -->
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
